import * as React from "react"

const Question = (props) => (
    <svg
        width={16}
        height={16}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx={8} cy={8} r={7.5} transform="rotate(90 8 8)" stroke="#AAA" />
        <path
            d="M7.033 9.38c0-.546.067-.982.2-1.306.132-.324.374-.642.726-.955.355-.316.592-.572.709-.767.117-.2.176-.409.176-.627 0-.66-.305-.99-.914-.99-.29 0-.522.09-.698.269-.171.176-.261.42-.27.732H5.265c.007-.746.248-1.33.72-1.752.477-.421 1.125-.632 1.946-.632.828 0 1.47.2 1.927.603.458.399.686.963.686 1.693 0 .332-.074.647-.223.944-.148.293-.408.619-.779.978l-.475.451c-.296.286-.466.62-.51 1.002l-.023.358h-1.5Zm-.17 1.8c0-.262.088-.477.264-.645a.952.952 0 0 1 .686-.258c.277 0 .503.086.68.258.179.168.269.383.269.645 0 .258-.088.47-.264.638-.172.168-.4.252-.685.252-.286 0-.516-.084-.692-.252a.855.855 0 0 1-.258-.638Z"
            fill="#AAA"
        />
    </svg>
)

export default Question
